import { BankOperationSingleTypes } from 'constants/bankOperationTypes';
import { Directions } from 'constants/directions';

import { Dispatch, SetStateAction } from 'react';

import { RequestsBankOpsForm } from 'pages/Finance/RequestsBankOps/components/RequestsBankOpsForm';
import { useFormContext } from 'react-hook-form';
import { getId } from 'utils';

type Props = {
  isRelated: boolean;
  setIsRelated: Dispatch<SetStateAction<boolean>>;
  errors: any;
};

export const RequestsBankOpsEditForm: React.FC<Props> = ({ isRelated, setIsRelated, errors }) => {
  const { setValue } = useFormContext();

  const onTypeChange = (value: string) => {
    if (getId(value) === BankOperationSingleTypes.Percentage) {
      setValue('direction', `/admin/directions/${Directions.Payout}`);
    }
  };

  return (
    <RequestsBankOpsForm
      errors={errors}
      isEdit={true}
      isRelated={isRelated}
      isRelatedSwitcherDisabled={true}
      onTypeChange={onTypeChange}
      setIsRelated={setIsRelated}
    />
  );
};
